import React, { useEffect, useState } from "react";
import api from"../../api";
import Button from "../../components/Button";
import { FiCheck, FiRefreshCw, FiX, FiTrash2 } from "react-icons/fi";

export default function RouteZonesPage() {
  const [zones, setZones] = useState([]);
  const [editing, setEditing] = useState({}); // track changed row values
  const [original, setOriginal] = useState({}); // keep original data for reset
  const [newRow, setNewRow] = useState(null);

  // Fetch all zones
  const loadZones = async () => {
    const res = await api.get("/operation/route-zones/");
    setZones(res.data);
  };

  useEffect(() => {
    loadZones();
  }, []);

  // Handle change for editable rows
  const handleChange = (id, field, value, isNew = false) => {
    const key = isNew ? "new" : id;

    setEditing((prev) => ({
      ...prev,
      [key]: {
        ...(prev[key] || {}),
        [field]: value,
      },
    }));
  };

  // Save existing zone
  const saveRow = async (id) => {
    await api.patch(`/operation/route-zones/${id}/`, editing[id]);
    await loadZones();
    setEditing((prev) => {
      const copy = { ...prev };
      delete copy[id];
      return copy;
    });
  };

  // Reset row
  const resetRow = (id) => {
    setEditing((prev) => {
      const copy = { ...prev };
      delete copy[id];
      return copy;
    });
  };

  // Delete row
  const deleteRow = async (id) => {
    if (window.confirm("آیا مطمئن هستید؟")) {
      await api.delete(`/operation/route-zones/${id}/`);
      loadZones();
    }
  };

  // Save new row
  const saveNewRow = async () => {
    await api.post(`/operation/route-zones/`, editing["new"]);
    setNewRow(null);
    await loadZones();
    setEditing((prev) => {
      const copy = { ...prev };
      delete copy["new"];
      return copy;
    });
  };

  // Reset new row
  const resetNewRow = () => {
    setNewRow(null);
    setEditing((prev) => {
      const copy = { ...prev };
      delete copy["new"];
      return copy;
    });
  };

  // Add new row
  const addRow = () => {
    setNewRow({
      name: "",
      lower_bound_km: "",
      upper_bound_km: "",
      cost_per_kg: "",
      fixed_cost: "",
      fragile_coefficient: 1,
      unpackable_coefficient: 1,
      liquid_coefficient: 1,
      corrosive_coefficient: 1,
      flammable_coefficient: 1,
    });
  };

  const renderInput = (id, field, value, isNew = false) => {
    const key = isNew ? "new" : id;

    const updatedValue =
      editing[key] && editing[key][field] !== undefined
        ? editing[key][field]
        : value;

    return (
      <input
        type="text"
        className="border p-1 w-full rounded text-sm text-gray-900"
        value={updatedValue}
        onChange={(e) =>
          handleChange(id, field, e.target.value, isNew)
        }
      />
    );
  };

  return (
    <div className="p-6">

    <Button variant={"primary"} onClick={addRow} children={"افزودن زون"} />

      <div className="overflow-x-auto pt-[24px]">
          <table className="table-auto w-full ">
              <thead className="bg-[#1E3A5F] text-[#FFC107]">
              <tr className="text-right">
                  <th className="border p-2 text-xs font-medium">نام زون</th>
                  <th className="border p-2 text-xs font-medium">حد پایین</th>
                  <th className="border p-2 text-xs font-medium">حد بالا</th>
                  <th className="border p-2 text-xs font-medium">هزینه حمل (kg)</th>
                  <th className="border p-2 text-xs font-medium">هزینه ثابت</th>
                  <th className="border p-2 text-xs font-medium">شکستنی</th>
                  <th className="border p-2 text-xs font-medium">غیر استاندارد</th>
                  <th className="border p-2 text-xs font-medium">مایعات</th>
                  <th className="border p-2 text-xs font-medium">خورنده</th>
                  <th className="border p-2 text-xs font-medium">اشتعال‌پذیر</th>
                  <th className="border p-2 text-xs font-medium">عملیات</th>
              </tr>
              </thead>

              <tbody>
              {/* Row جدید */}
              {newRow && (
                  <tr className="bg-green-50">
                      {Object.entries(newRow).map(([field, value]) => (
                          <td className="border p-2" key={field}>
                              {renderInput("new", field, value, true)}
                          </td>
                      ))}
                      <td className="border p-2 flex gap-2">
                          {/* آیکن تیک تایید */}
                          <button
                              className="text-green-600 hover:text-green-800"
                              onClick={saveNewRow}
                          >
                              <FiCheck size={20}/>
                          </button>
                          {/* آیکن ریست بازنشانی */}
                          <button
                              className="text-gray-600 hover:text-gray-800"
                              onClick={resetNewRow}
                          >
                              <FiRefreshCw size={20}/>
                          </button>
                      </td>
                  </tr>
              )}

              {/* سطرهای موجود */}
              {zones.map((zone) => {
                  const isEdited = editing[zone.id] !== undefined;

                  return (
                      <tr key={zone.id}>
                          {Object.entries(zone).map(([field, value]) => {
                              if (
                                  ["id", "created_at", "updated_at"].includes(field)
                              )
                                  return null;

                              return (
                                  <td className="border p-2" key={field}>
                                      {renderInput(zone.id, field, value)}
                                  </td>
                              );
                          })}

                          <td className="border p-2 flex gap-2">
                              {/* دکمه تایید */}
                              {isEdited && (
                                  <button
                                      className="text-green-600 hover:text-green-800"
                                      onClick={() => saveRow(zone.id)}
                                  >
                                      <FiCheck size={20}/>
                                  </button>
                              )}

                              {/* دکمه بازنشانی */}
                              {isEdited && (
                                  <button
                                      className="text-gray-600 hover:text-gray-800"
                                      onClick={() => resetRow(zone.id)}
                                  >
                                      <FiRefreshCw size={20}/>
                                  </button>
                              )}

                              {/* دکمه حذف */}
                              <button
                                  className="text-red-600 hover:text-red-800"
                                  onClick={() => deleteRow(zone.id)}
                              >
                                  <FiTrash2 size={20}/>
                              </button>
                          </td>
                      </tr>
                  );
              })}
              </tbody>
          </table>
      </div>
    </div>
  );
}
